import { Component, Input } from '@angular/core';
import { TableColumn } from '../../table.model';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

export interface CellRenderer<T> {
  /**
   * Data to be used */
  data?: Record<string, any>;
  /**
   * Config to be used to read/format data read
   */
  config?: T;
  /**
   * Method to execute reading of the data using given configuration
   */
  render(): void;
}

@Component({
  selector: 'cbre-open-in-new, [cbreOpenInNew]',
  imports: [MatIconModule, MatTooltipModule],
  template: `
    <div
      class="fx--h fx--juc-start fx--ali-center"
      [matTooltip]="tooltipText"
      matTooltipPosition="above"
      matTooltipClass="tooltip-action-icon"
    >
      <mat-icon class="icon go-to-record" (click)="openInNewTab()">open_in_new</mat-icon>
    </div>
  `,
  styleUrls: ['./open-in-new.component.scss'],
})
export class OpenInNewComponent implements CellRenderer<TableColumn> {
  @Input() data!: Record<string, any>;
  @Input() set config(value: TableColumn | undefined) {
    this.customConfig = value?.context?.data as Record<string, any>;
    this.tooltipText = value?.tooltip ?? '';
  }
  customConfig?: Record<string, any>;
  tooltipText = '';

  openInNewTab() {
    window.open(`/records/${this.customConfig?.entity}/${this.data?.entity?.id}/edit`, '_blank');
  }

  render(): void {
    // required by CellRenderer
  }
}
